import { Injectable } from '@angular/core';
import {  Observable } from 'rxjs';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Fce } from './fce';
import { Location } from '@angular/common';
import { SharedService } from '../_shared/shared.service';


@Injectable()
export class AccessGuard implements CanActivate {
  constructor(protected shared: SharedService, private router: Router, private location: Location) { }

  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const requiresLogin = route.data.requiresLogin;
    const app = route.data.app;
    const rights = route.data.rights;
    const urights = this.shared.rightsAll;

    //console.log(route)
    if (requiresLogin && !this.shared.isLoggedIn()) {
      if (route.url)
        this.shared.setAny("last_wanted_url", this.location.path())
      if (!route.data.isMainPage)
        this.shared.warning("You are not logged in")
      this.router.navigate(['/login']);
      return false;
    }
    if (app && rights) {
      // console.log(app, urights)
      if (!urights) {
        return new Promise((resolve, reject) => {
          const watcher = this.shared.rightsAllWatch.subscribe((urights) => {
            if (urights) {
              watcher.unsubscribe();
              if (this.controlRights(app, rights, urights))
                resolve(true)
              else reject()
            }
          })
        });
      }

      return this.controlRights(app, rights, urights)
    }
    return true;
  }

  controlRights(app: string, rights: [string], urights: any) {
    if (!urights)
      return false;
    if (!urights[app]) {
      this.shared.warning("You dont have access here!")
      this.router.navigate(['/login']);
      return false;
    }

    if (Fce.empty(rights)) {
      return true
    }
    
    // OR logic
    for (const r of rights) {
      if (urights[app][r])
        return true;
    }
    this.shared.warning("You dont have user rights!")
    this.router.navigate(['/login']);
    return false;
  }
}